import { Text } from "rebass";
import styled from "styled-components";
import { DynamicNextLink } from "./dynamic-next-link";

const Label = ({ title, link, showBackground }) => {
  return (
    <S_DynamicNextLink link={link}>
      <S_Text
        bg={showBackground ? "yellow" : "transparent"}
        color={showBackground ? "black" : "white"}
        textAlign="center"
        p={2}
        fontFamily="boldItalic"
        letterSpacing={1.14}
        fontSize={2}
      >
        {title}
      </S_Text>
    </S_DynamicNextLink>
  );
};

const S_DynamicNextLink = styled(DynamicNextLink)`
  display: inline-block;

  &:hover {
    opacity: ${props => (props.link ? 0.2 : 1)};
  }
`;

const S_Text = styled(Text)`
  text-transform: uppercase;
`;

export { Label };
